<template>
	<div class="section padding"><div>
		<a class="breadcrumb mb-0 px-0" @click="$router.back()">
			<div class="icon back"></div>
			<div class="text">{{ $t("nav.back") }}</div>
		</a>
	</div></div>
</template>
